import { AnalyticsEvents, trackEvent } from "./analytics";
import { getScheduleFilterAnalyticsParams, buildEmptySearchLabel } from "./scheduleFilterAnalyticsParams";

export { getScheduleFilterAnalyticsParams };

/** @returns {Record<string, string | number>} */
const baseParams = (programName) => ({
  item_name: programName,
  location: typeof window !== "undefined" ? window.location.pathname : undefined,
});

export const trackScheduleFilterView = (programName) => {
  trackEvent(AnalyticsEvents.SCHEDULE_FILTER_VIEW, baseParams(programName));
};

export const trackScheduleFilterDay = (programName, day, selected, filter) => {
  trackEvent(AnalyticsEvents.SCHEDULE_FILTER_DAY, {
    ...baseParams(programName),
    label: `${day}:${selected ? "on" : "off"}`,
    ...getScheduleFilterAnalyticsParams(filter),
  });
};

export const trackScheduleFilterTime = (programName, timeOfDay, filter) => {
  trackEvent(AnalyticsEvents.SCHEDULE_FILTER_TIME, {
    ...baseParams(programName),
    label: timeOfDay,
    ...getScheduleFilterAnalyticsParams(filter),
  });
};

export const trackScheduleFilterAge = (programName, filter) => {
  const years = filter?.childAgeYears;
  const months = filter?.childAgeMonths ?? 0;
  const label =
    years === null || years === undefined || years === ""
      ? "any"
      : `${years}y_${months}m`;

  trackEvent(AnalyticsEvents.SCHEDULE_FILTER_AGE, {
    ...baseParams(programName),
    label,
    ...getScheduleFilterAnalyticsParams(filter),
  });
};

export const trackScheduleFilterOpenSpots = (programName, enabled, filter) => {
  trackEvent(AnalyticsEvents.SCHEDULE_FILTER_OPEN_SPOTS, {
    ...baseParams(programName),
    label: enabled ? "on" : "off",
    ...getScheduleFilterAnalyticsParams(filter),
  });
};

export const trackScheduleFilterClear = (programName, clearLocation, filter) => {
  trackEvent(AnalyticsEvents.SCHEDULE_FILTER_CLEAR, {
    ...baseParams(programName),
    label: clearLocation,
    ...getScheduleFilterAnalyticsParams(filter),
  });
};

export const trackScheduleFilterResults = (
  programName,
  { matchCount, sourceCount },
  filter,
  emptyReason
) => {
  const isEmpty = matchCount === 0;
  trackEvent(AnalyticsEvents.SCHEDULE_FILTER_RESULTS, {
    ...baseParams(programName),
    label: isEmpty
      ? buildEmptySearchLabel(filter, emptyReason || "no_matches")
      : "has_matches",
    match_count: matchCount,
    source_count: sourceCount,
    ...getScheduleFilterAnalyticsParams(filter),
    ...(isEmpty ? { empty_reason: emptyReason?.type || "no_matches" } : {}),
  });
};

export const trackScheduleFilterFirstUse = (programName, filter) => {
  trackEvent(AnalyticsEvents.SCHEDULE_FILTER_FIRST_USE, {
    ...baseParams(programName),
    ...getScheduleFilterAnalyticsParams(filter),
  });
};

export const trackScheduleFilterEmptyView = (programName, filter) => {
  trackEvent(AnalyticsEvents.SCHEDULE_FILTER_EMPTY_VIEW, {
    ...baseParams(programName),
    ...getScheduleFilterAnalyticsParams(filter),
  });
};
